import {MenuProps} from "./MenuProps";
import {Col, Row} from "react-bootstrap";
import {Typography} from "@mui/material";
import React, {useState} from "react";
import PrettyBox from "../PrettyBox/PrettyBox.tsx";
import IranSanse from "../Typography/IranSanse.tsx";

export default function (props: MenuProps) {

    return <>
        <PrettyBox Width={'100%'} Height={'120px'}>
            <Row className="g-0 pb-3 pt-4 mx-0 d-flex justify-content-center"
                 style={{width: '100%'}}>
                {
                    props.Menus.map(menu => {
                        return (
                            <Col key={menu.id}
                                 className="  text-center  mx-0 px-0">
                                <Row className="g-0">
                                    <div onClick={() => {
                                        props.OnSelected(menu)
                                    }} className="mx-0 px-0">
                                        <Col className="d-flex justify-content-center">
                                            <div
                                                className={"footerMenuBox2"}>
                                                <img src={"/Icons/" + menu.iconId + ".png"} alt=""/>
                                            </div>
                                        </Col>
                                    </div>
                                </Row>
                                <Row className='footerText text-muted text-center g-0'>
                                    <Col className='text-center pt-2'>
                                        <IranSanse>{menu.title}</IranSanse>
                                    </Col>
                                </Row>
                            </Col>
                        )
                    })
                }
            </Row>
        </PrettyBox>
    </>
}